import { c, classy, m } from '@onfido/castor';
import React, { useState } from 'react';
import { withRef } from '../../utils';
import { getFormValues } from './getFormValues';
import { FormProvider } from './useForm';
export { useForm } from './useForm';
export const Form = withRef(function Form({ disabled, onChange, onInvalid, onSubmit, className, ...restProps }, ref) {
    const [touched, setTouched] = useState();
    return (React.createElement(FormProvider, { value: { disabled, touched } },
        React.createElement("form", { ...restProps, ref: ref, className: classy(c('form'), m({ disabled }), className), onChange: (event) => onChange === null || onChange === void 0 ? void 0 : onChange(event, getFormValues(event.currentTarget)), onInvalid: (event) => {
                event.preventDefault();
                setTouched(true);
                onInvalid === null || onInvalid === void 0 ? void 0 : onInvalid(event);
            }, onSubmit: (event) => {
                var _a;
                event.preventDefault();
                setTouched(true);
                if (disabled)
                    return;
                // prevent disabled buttons from submitting
                // https://github.com/facebook/react/issues/7711
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const { submitter } = event.nativeEvent;
                if ((_a = submitter) === null || _a === void 0 ? void 0 : _a.disabled)
                    return;
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event, getFormValues(event.currentTarget));
            } })));
});
//# sourceMappingURL=form.js.map